import { useQuery } from '@tanstack/react-query';
import { type AxiosError } from 'axios';
import ms from 'ms';

import { toast } from '@hivebrite/design-system/Toast';

import { getProgram } from 'hb-react/frontoffice/apps/Mentoring/requests';
import { type Program } from 'hb-react/frontoffice/apps/Mentoring/types';
import { QUERY_KEYS } from 'hb-react/shared/apps/Mentoring/constants';

interface GetProgramParams {
  programId: number;
  topicId?: string;
}

export const useGetProgram = ({ programId, topicId }: GetProgramParams) =>
  useQuery<Program, AxiosError>({
    queryKey: [QUERY_KEYS.program, programId],
    queryFn: async ({ signal }) => {
      try {
        return await getProgram({
          programId,
          signal,
          topicId: topicId ? Number(topicId) : undefined,
        });
      } catch (error) {
        if (error.response?.status === 500) {
          toast.error(__('Sorry, an error occurred'));
        }
        throw error;
      }
    },
    staleTime: ms('5m'),
    enabled: !!programId,
  });
